import '../tables/Table.module.css'
function FactorTableValidation(props) {

    const colNames =  ['invalid factor', 'error type', 'validation error', 'please correct'];   
    let tableHead = (
        <>
            <tr style={{fontSize: '14px'}}>
                {colNames.map((columnName, index) => (<th key={index} >{columnName}</th>))}
            </tr>
        </>);

    let tableRows = (<></>);
    tableRows = props.invalidFactors.map((factor, id) => (
        <tr key={`row_${id}`}>
            <td key={`name_${id}`} style={{verticalAlign: 'top'}}>
                <div style={{ fontSize: '14px' }}>
                    {factor.name}
                </div>
            </td>
            <td key={`error_type_${id}`} style={{verticalAlign: 'top'}}>
                <div style={{ fontSize: '14px' }}>
                    {factor.error_type}
                </div>
            </td>
            <td key={`error_msg_${id}`} style={{verticalAlign: 'top'}}>
                <div style={{ fontSize: '14px', color:'red'}}>
                    {factor.err_msg.map((msg, idx) => (<div key={idx}>{msg}</div> ))}
                </div>
            </td>
            <td key={`range_${id}`} style={{verticalAlign: 'top'}}>
                <div style={{ display:'flex', fontSize: '14px' }}>
                <input 
                    id={`range_min_${factor.factor_id}`}
                    type='number' 
                    placeholder='min' 
                    autoComplete='false' 
                    value={props.factors[factor.factor_id].range_min !== null ? props.factors[factor.factor_id].range_min : ''} 
                    onChange={props.inputHandler}
                    style={{fontSize: '14px', border:'0.5px solid var(--aixelo-gray)', width:'60px'}}/>
                    <p style={{margin:'0px', padding:'0px', paddingLeft:'5px', paddingRight:'5px', fontSize: '14px'}}>-</p>
                <input 
                    id={`range_max_${factor.factor_id}`}
                    type='number' 
                    placeholder='max' 
                    autoComplete='false' 
                    value={props.factors[factor.factor_id].range_max !== null ? props.factors[factor.factor_id].range_max : ''} 
                    onChange={props.inputHandler}
                    style={{fontSize: '14px', border:'0.5px solid var(--aixelo-gray)', width:'60px'}}/>
                </div>
            </td>
        </tr>
    ));





    return(<>
        <table style={{ tableLayout: 'auto' }}>
            <thead >
                {tableHead}
            </thead>
            <tr><div style={{height: '4px'}} colSpan={colNames.length}></div></tr>
            <tbody style={{border: '0.5px solid var(--aixelo-gray-light)'}}>
                {tableRows}
            </tbody>
        </table>
    </>
    );

}


export default FactorTableValidation;
